import { ReactNode } from 'react';
import { Asset, Video } from '../../components/common/model';
import { MappedAEMProperties } from '../../types';
import { HeadingLevel } from '../utils/HeadingMapper';
import { Api } from './apiSpec';

export type LinkModel = {
  link: string;
  label: string;
  isCookieSection: boolean;
};

export type Richtext = string;

export type ContentFragmentBase = {
  uniqueId: string;
  contentFragmentType?: string;
};

export type ContentBlock = {
  heading?: string;
  content?: Richtext;
  link?: string;
  linkLabel?: string;
  asset?: Asset;
  video?: Video;
} & ContentFragmentBase;

export enum AemPageType {
  external = 'external-link',
  internal = 'cq:PageContent',
}

export type ResourceType = AemPageType | string;

export type Resource = {
  label: string;
  link: string;
  type: ResourceType;
};

export type ViewType = 'list' | 'grid';

export type BaseAemTable = {
  pageSize: number;
  showPageSizeSelector: boolean;
  pageSizeOptions: number[];
  heading?: string;
  icon?: string;
  headingLevel?: HeadingLevel;
};

export type BaseModalProps = {
  dialogTitle: string;
  noItemsSelectedMessage: string;
};

export type CommonAemModalProps = {
  buttonLabel: string;
  successMessage: string;
} & BaseModalProps;

export type CommonModalProps = {
  isModalOpened: boolean;
  showFacilitiesTab?: boolean;
  onSuccess: (fullSuccess?: boolean) => void;
  onCancel: () => void;
} & BaseModalProps;

export type MetaAttributes = 'property' | 'name';
export type MetaAttributesValues = {
  property: 'applicationLoader';
  name: 'og:title' | 'og:description' | 'robots' | 'description';
};

export type AemReportSeparator = '\\t' | ',' | ';' | ':' | '|';

export type ReportConfigBase = {
  nameFormat: string;
  separator?: AemReportSeparator;
  disclaimer?: string;
  columns?: { name: string; label: string }[];
  mapping?: Record<string, string>;
};

export type ReportConfig = ReportConfigBase & ContentFragmentBase;

export type CommonReportConfigProps = {
  reportConfig?: ReportConfig;
  reportButtonLabel?: string;
};

export type LearningDetailsBaseProps = {
  nameLabel?: string;
  descriptionLabel?: string;
  elementsLabel?: string;
  associatedAssetsLabel?: string;
  associateAssetDialogTitle?: string;
  associateAssetDialogNoItemsSelectedMessage?: string;
} & MappedAEMProperties;

export type AemLearningDetailsBaseProps<T extends Api.DocumentLibrary | Api.EventDetails> = {
  detailOptions?: Array<{
    label: string;
    property: keyof T;
  }>;
} & LearningDetailsBaseProps;

export type LearningDetailsProps<T extends Api.DocumentLibrary | Api.EventDetails> = {
  error?: Error;
  isLoading?: boolean;
  data?: T | null;
  button: ReactNode;
} & AemLearningDetailsBaseProps<T>;
